<template>
    <div class="basic_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('Member Center')}}</div>
        </div>
        <div class="wrap" @touchmove.prevent>
            <van-swipe
                    class="my-swipe"
                    @change="onSwipeChange"
                    :initial-swipe="currentIndex"
                    @touchstart.stop
                    @touchmove.stop>
                <van-swipe-item
                        v-for="item in levelList"
                        :key="item.id"
                        class="swiper-item"
                        :style="{
                        backgroundImage: 'url(' + item.bg_img + ')',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        margin: '10px 15px',
                        color: item.color,
                         }"
                >
                    <div class="current" v-if="userLevel<item.id">
                        <div class="background notlocked"></div>
                        <div class="inner">{{$t('Not unlocked')}}</div>
                    </div>
                    <div class="level">
                        <img :src="item.icon"/>
                        {{ item.name }}
                    </div>
                    <div class="desc">{{$t('Keep going Every step brings you closer to becoming a Five-Star Leader!')}}</div>
                    <div class="desc mt-10">{{$t('Permissions for this level have been unlocked.')}}</div>
                </van-swipe-item>
            </van-swipe>

            <div class="privilege-section">
                <div class="section-hd">{{$t('Employee Benefits')}}</div>
                <div class="section-bd acea-row">
                    <div class="item">
                        <div class="image-wrap acea-row row-center-wrapper">
                            <img class="image" src="@/assets/images/rebates.svg">
                        </div>
                        <div class="break-wrap pd-lr-5">{{$t('Weekly Salary')}}</div>
                        <div class="break-wrap pd-lr-5">{{$t('currency')}} {{ levelList[currentIndex] ? Number(levelList[currentIndex].weekly_salary).toFixed(2) : '0.00' }}</div>
                    </div>
                    <div class="item">
                        <div class="image-wrap acea-row row-center-wrapper">
                            <img class="image" src="@/assets/images/medal.svg">
                        </div>
                        <div class="break-wrap pd-lr-5">{{$t('Exclusive Badge')}}</div>
                    </div>
                    <div class="item">
                        <div class="image-wrap acea-row row-center-wrapper">
                            <img class="image" src="@/assets/images/free_withdrawals.svg">
                        </div>
                        <div class="break-wrap pd-lr-5">{{$t('Free Withdrawal')}}</div>
                        <div class="break-wrap pd-lr-5">{{ levelList[currentIndex] ? Number(levelList[currentIndex].free_withdrawal_num).toFixed(2) : '0' }} times / month</div>
                    </div>
                    <div class="item">
                        <div class="image-wrap acea-row row-center-wrapper">
                            <img class="image" src="@/assets/images/highintegral.svg">
                        </div>
                        <div class="break-wrap pd-lr-5">{{$t('Daily Salary')}}</div>
                        <div class="break-wrap pd-lr-5">{{ levelList[currentIndex] ? Number(levelList[currentIndex].daily_salary).toFixed(2) : '0' }} / daily</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="skill-wrapper">
            <div class="skill-section">
                <div class="section-hd">{{$t('Quick Level-Up Tips')}}</div>
                <div class="section-bd">

                    <div class="item acea-row row-middle">
                        <div class="image-wrap acea-row row-center-wrapper">
                            <img class="image" src="@/assets/images/user-vip-qd.png">
                        </div>
                        <div class="text">
                            <div class="title">
                                {{$t('Salary')}}
                            </div>
                            <div class="info">{{$t('Tap the button on the right to get your Leader’s Salary.')}}</div>
                        </div>
                        <div class="link acea-row row-middle" :class="{ disabled: isSign }" @click="signBtn">
                            {{ isSign ? $t('Received') : $t('Get') }}</div>
                    </div>

                    <!--                    <div class="item acea-row row-middle">-->
                    <!--                        <div class="image-wrap acea-row row-center-wrapper">-->
                    <!--                            <img class="image" src="https://multi-store.crmeb.net/statics/images/user-vip-gm.png" draggable="false">-->
                    <!--                        </div>-->
                    <!--                        <div class="text">-->
                    <!--                            <div class="title">-->
                    <!--                                {{$t('Shopping')}}-->
                    <!--                            </div>-->
                    <!--                            <div class="info">购买商品可获得对应的经验值</div>-->
                    <!--                        </div>-->
                    <!--                        <a href="#" class="link acea-row row-middle">{{$t('Go Buy')}}</a>-->
                    <!--                    </div>-->

                    <div class="item acea-row row-middle">
                        <div class="image-wrap acea-row row-center-wrapper">
                            <img class="image" src="@/assets/images/user-vip-yq.png">
                        </div>
                        <div class="text">
                            <div class="title">
                                {{$t('Invite Friends')}}
                            </div>
                            <div class="info">{{$t('Invite Friends to Register')}}</div>
                        </div>
                        <div class="link acea-row row-middle" @click="$router.push('/share')">{{$t('Go Invite')}}</div>
                    </div>



                </div>
            </div>
            <div>
                <!-- 职位任务 -->
                <div class="progress-warp">
                    <div class="font-14 font-bold">
                        {{ levelList[currentIndex] ? levelList[currentIndex].name : '' }} {{$t('Position Unlock')}}
                    </div>
                    <div class="mt-10 chip-color">{{$t('Invite')}} {{levelList[currentIndex].number}} {{$t('Official Members (VIP1 and above)')}}</div>
                    <div class="mt-20">
                        <van-progress pivot-text="" color="#0b9444" :percentage="totalPercentage" />
                    </div>
                    <div class="mt-10 font-bold">
                        {{levelList[currentIndex].total_now_level}} / {{ levelList[currentIndex] ? levelList[currentIndex].number : '' }}
                    </div>
<!--                    <div class="operate">-->
<!--                        <div class="submitbtn" v-if="subInfo.total >= levelList[currentIndex].number" @click="unlock">{{$t('Unlock')}}</div>-->
<!--                        <div class="notmet" v-else>{{$t('Not Met')}}</div>-->
<!--                    </div>-->
                </div>

                <!-- 周任务 -->
                <div class="progress-warp">
                    <div class="font-14 font-bold">
                        {{$t('Weekly Mission')}}
                    </div>
                    <div class="mt-10 chip-color">{{$t('Invite')}} {{levelList[currentIndex].week_task_number}} {{$t('Official Members (VIP1 and above)')}}</div>
                    <div class="mt-20">
                        <van-progress pivot-text="" color="#0b9444" :percentage="weekPercentage" />
                    </div>
                    <div class="mt-10 font-bold">
                        {{levelList[currentIndex].week_now_level}} / {{levelList[currentIndex].week_task_number}}
                    </div>
                    <div class="mt-10 chip-color font-bold">
                        {{$t('Complete to Claim')}}  {{$t('currency')}} {{ levelList[currentIndex] ? Number(levelList[currentIndex].week_task_reward).toFixed(2) : '0.00' }}
                    </div>
                </div>
            </div>
            <div class="rule-wrap">
                <div class="font-14 chip-color font-bold">{{$t('Job Rules')}}</div>
                <div class="mt-20" v-html="levelList[currentIndex].rule"></div>
            </div>
        </div>

        <div style="height: 20px;"></div>
    </div>
</template>

<script>
    import Fetch from "../../utils/fetch";

    export default {
        name: "index",
        data() {
            return {
                levelList: [],
                levelInfo: {},
                userLevel: '',
                currentIndex: 0, // 当前选中的 swipe 索引
                isSign: false, // 今日是否签到
                running_days: 0, // 已签到天数
                subInfo: {},
                totalPercentage: 0,
                weekPercentage: 0,
            }
        },
        created() {
            this.$parent.footer('index', false);
        },
        mounted() {
            this.getLevels();
            this.init();
        },
        methods: {

            onSwipeChange(index) {
                this.currentIndex = index; // 更新当前索引

                this.totalPercentage = Math.min((this.levelList[this.currentIndex].total_now_level / this.levelList[this.currentIndex].number) * 100, 100);
                this.weekPercentage =  Math.min((this.levelList[this.currentIndex].week_now_level / this.levelList[this.currentIndex].week_task_number) * 100, 100);
            },
            getLevels() {
                Fetch('/index/levelsInfo', { }).then(res => {
                    this.levelList = res.data.level_list;
                    this.levelInfo = res.data.level_info;
                    this.userLevel = res.data.job_level;
                    this.subInfo = res.data.sub_info;
                    this.currentIndex = this.levelList.findIndex(item => item.id === this.userLevel);
                    this.currentIndex = this.currentIndex === -1 ? 0 : this.currentIndex + 1;


                    this.totalPercentage = Math.min((this.subInfo.total / this.levelList[this.currentIndex].number) * 100, 100);
                    this.weekPercentage =  Math.min((this.subInfo.week / this.levelList[this.currentIndex].week_task_number) * 100, 100);
                })
            },
            init() {
                Fetch('/user/jobSignData').then(r => {
                    // this.allDays = r.data.date_list;
                    this.isSign = r.data.isSign;
                    this.running_days = r.data.signin_days;
                })
            },
            // 签到
            signBtn() {
                if (this.isSign) return;  // 已签到 → 不执行
                Fetch('/user/jobSign').then(r => {
                    if(r.code == 1) {
                        this.$toast('Successful,You earned '+ r.data.reward_num);
                        this.running_days = r.data.days;
                        this.isSign = true;
                        setTimeout(() => {
                            this.init();
                        }, 2000);
                    }
                })
            },
            // 职位解锁
            unlock() {
                if (this.subInfo.total < this.levelList[this.currentIndex].number) return;

                Fetch('/user/jobUnlock').then(r => {
                    if(r.code == 1) {
                        this.$toast('Unlock successfully.');
                        setTimeout(() => {
                            this.getLevels();
                            this.init();
                        }, 2000);
                    }
                })
            },
        },
    }
</script>

<style lang="less" scoped>

    .basic_wrap {

    }
    .red_top_bg {
        background: #061926;
    }
    .back_left {
        background: url(../../views/images/item/back.png) no-repeat center center;
    }
    .big_tit{
        color: #fff;
    }
    .wrap {
        background: #061926;
        padding: 10px 0;
    }

    .my-swipe .van-swipe-item {
        color: #fff;
        height: 155px;
        width: calc(100vw - 30px)!important;
        border-radius: 20px;
        overscroll-behavior-x: contain;
    }
    .swiper-item {
        position: relative;
        height: 100%;
        padding: 35px 24px 18px;
    }
    .swiper-item .current {
        position: absolute;
        top: 0;
        left: 0;
    }
    .swiper-item .current .background {
        width: 120px;
        height: 30px;
        border-bottom-right-radius: 19px;
        border-top-left-radius: 20px;
        opacity: .3;
    }
    .notlocked {
        background: #949494;
    }
    .locked {
        background: #0870D9;
    }
    .swiper-item .current .inner {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        font-weight: 500;
        font-size: 14px;
        align-items: center;
        justify-content: center;
        display: flex;
        flex-wrap: wrap;
    }
    .swiper-item .level {
        font-weight: 700;
        font-size: 18px;
        display: flex;
        align-items: center;     /* 垂直居中对齐 */
        gap: 8px;
        line-height: 45px;
    }
    .swiper-item .level img {
        height: 30px;
    }
    .swiper-item .desc {
        font-size: 12px;
        line-height: 17px;
        height: 25px;
        padding-left: 10px;
    }
    .disabled {
        pointer-events: none; /* 禁止点击 */
        opacity: 0.5;         /* 置灰效果 */
        cursor: not-allowed;
    }
    .rule-wrap {
        margin: 12px 10px;
        margin-top: 20px;
        background: #fff;
        border-radius: 8px;
        padding: 20px;
    }
</style>